import GuaranteedResIframeModal from './GuaranteedResIframeModal';

export default GuaranteedResIframeModal;
